var render = function render(){var _vm=this,_c=_vm._self._c;return _c('App',{attrs:{"title":"分配Co-Pilot","border":false}},[_c('DynamicForm',{ref:"form",attrs:{"rules":_vm.rules,"fieldData":_vm.fieldData},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_c('FooterBtn',{on:{"cancel":_vm.chinal,"ok":_vm.onClickRight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }